export default __webpack_public_path__ + "static/media/success.e8e0718d.gif";